<div class="flex-column full-screen">
  <mat-toolbar
    class="navbar-color mat-elevation-z8 p-0 flex-row align-center navbar-header"
  >
    <button
      mat-button
      (click)="drawer.toggle()"
      aria-label="Toggle navigation menu"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <button mat-button routerLink="/" aria-label="Go to home">
      <mat-icon>home</mat-icon>
    </button>

    <span class="spacer"></span>

    <button
      mat-icon-button
      (click)="openCommandPalette()"
      aria-label="Search or press Ctrl+K"
      title="Search (Ctrl + K)"
    >
      <mat-icon>search</mat-icon>
    </button>

    <button
      mat-icon-button
      (click)="toggleTheme()"
      aria-label="Toggle dark/light mode"
    >
      <mat-icon>
        @if (currentTheme === "light-theme") {
          dark_mode
        } @else {
          light_mode
        }
      </mat-icon>
    </button>

    <div class="desktop-nav">
      <button
        mat-button
        routerLink="/checkins"
        routerLinkActive="router-link-active no-border"
      >
        Checkins
      </button>
      <button
        mat-button
        routerLink="/top-beers"
        routerLinkActive="router-link-active no-border"
      >
        Top Drinks
      </button>
      <button
        mat-button
        routerLink="/badges"
        routerLinkActive="router-link-active no-border"
      >
        Badges
      </button>
      <button
        mat-button
        routerLink="/map"
        routerLinkActive="router-link-active no-border"
      >
        Map
      </button>
      <button
        mat-button
        routerLink="/beer-history"
        routerLinkActive="router-link-active no-border"
      >
        History
      </button>
      <button
        mat-button
        routerLink="/stats"
        routerLinkActive="router-link-active no-border"
      >
        Stats
      </button>
      <button
        mat-button
        routerLink="/insights"
        routerLinkActive="router-link-active no-border"
      >
        Insights
      </button>
      <button
        mat-button
        routerLink="/wishlist"
        routerLinkActive="router-link-active no-border"
      >
        Wishlist
      </button>
    </div>
  </mat-toolbar>

  @if (hasLoadError) {
    <div class="global-error-banner flex-row align-center justify-center">
      <mat-icon class="error-banner-icon">warning</mat-icon>
      <span class="error-banner-message">
        Unable to load the latest drink data. You may be offline or the data
        service is temporarily unavailable.
      </span>
      <button
        mat-flat-button
        color="warn"
        class="retry-button"
        (click)="retryLoad()"
        aria-label="Retry loading data"
      >
        <mat-icon>refresh</mat-icon> Retry
      </button>
    </div>
  }

  <nav class="mobile-bottom-nav">
    <a
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <mat-icon>home</mat-icon>
      <span>Home</span>
    </a>
    <a routerLink="/checkins" routerLinkActive="active">
      <mat-icon>room</mat-icon>
      <span>Checkins</span>
    </a>
    <a routerLink="/beer-history" routerLinkActive="active">
      <mat-icon>history</mat-icon>
      <span>History</span>
    </a>
    <a routerLink="/map" routerLinkActive="active">
      <mat-icon>map</mat-icon>
      <span>Map</span>
    </a>
    <a routerLink="/top-beers" routerLinkActive="active">
      <mat-icon>emoji_events</mat-icon>
      <span>Top</span>
    </a>
    <a routerLink="/stats" routerLinkActive="active">
      <mat-icon>insert_chart</mat-icon>
      <span>Stats</span>
    </a>
    <a routerLink="/insights" routerLinkActive="active">
      <mat-icon>insights</mat-icon>
      <span>Insights</span>
    </a>
    <a routerLink="/wishlist" routerLinkActive="active">
      <mat-icon>list</mat-icon>
      <span>Wishlist</span>
    </a>
  </nav>

  <mat-drawer-container autosize class="background main-container">
    <mat-drawer #drawer>
      <div class="flex-column">
        <button
          mat-button
          routerLink="/checkins"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>room</mat-icon>Checkins
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/top-beers"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>emoji_events</mat-icon>Top Drinks
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/badges"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>badge</mat-icon>Badges
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/map"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>map</mat-icon>Map
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/beer-history"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>history</mat-icon>Drink History
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/stats"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>insert_chart</mat-icon>Stats
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/insights"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>insights</mat-icon>Insights
        </button>
        <mat-divider></mat-divider>
        <button
          mat-button
          routerLink="/wishlist"
          routerLinkActive="selected no-border txt-bold"
          class="drawer-nav-button"
        >
          <mat-icon>list</mat-icon>Wishlist
        </button>
        <mat-divider></mat-divider>
      </div>
    </mat-drawer>

    <div [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </mat-drawer-container>

  @defer (on idle) {
    <app-info-fab></app-info-fab>
  }

  @defer (on idle) {
    <app-scroll-to-top></app-scroll-to-top>
  }
</div>
